import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Field } from 'formik';

import Button from '../../../core-components/Button';
import ValidatedFormInputField from '../../../core-components/ValidatedFormInputField/ValidatedFormInputField';

import styles from './ChangePassword.module.scss';
import { PASSWORD_RULES } from '../../../utils/commonConstant';
import { SV_ERRORS } from '../../../utils/svErrorsCode';
import { isEmpty } from 'lodash';
import PasswordRulesBox from '../../../core-components/DynamicPasswordRules/PasswordRulesBox';
import { checkPasswordRules } from '../../../utils/ValidationSchema';
import PasswordValidatedFormInputField from '../../../core-components/PasswordValidatedInputField/PasswordValidatedFormInputField';

export default (props) => {
  const { handleSubmit } = props;
  const [matchingResults, setMatchingResults] = useState(PASSWORD_RULES);

  const onPasswordChange = (val) => {
    if (!isEmpty(val)) {
      const res = checkPasswordRules(val);
      setMatchingResults(res);
    }
  };

  useEffect(() => {
    const newPassword = props.values.newPassword;

    onPasswordChange(newPassword);

    return () => {
      setMatchingResults(PASSWORD_RULES);
    };
  }, [props.values]);

  return (
    <div>
      <div className={styles.CardMain}>
        {props.location?.state?.sv_error_code ==
        SV_ERRORS.password_missing_to_expire.sv_error_code ? (
          <h4>Set Password</h4>
        ) : (
          <h4>Change Password</h4>
        )}
        {props.location?.state?.sv_error_code && (
          <div className={styles.errorMsg}>
            {SV_ERRORS[props.location?.state?.sv_error_code].description}
          </div>
        )}
        <Form onSubmit={handleSubmit}>
          <Field
            className={styles.FormField}
            component={PasswordValidatedFormInputField}
            type='text'
            name='newPassword'
            placeholder='Enter New Password'
            label='New Password'
          />
          <Field
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            className={styles.FormField}
            component={ValidatedFormInputField}
            noAutoTrimmedRequired={true}
            type='password'
            name='confirmNewPassword'
            placeholder='Re-enter Password'
            label='Re-enter Password'
          />
          <label className='form-label'>New password must satisfy the following conditions</label>
          <PasswordRulesBox
            showAsListOnly={isEmpty(props.values.newPassword)}
            matchingResults={matchingResults}
          />
          <div>
            <Button
              className='mt-5 mb-5'
              type='submit'
              disabled={
                !props.values.newPassword ||
                !props.values.confirmNewPassword ||
                !isEmpty(props.errors)
              }
            >
              Change Password
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};
